import React from 'react';
import { styles } from './ProductBannerHeader.css';
import CrazyFont from '@jbhi-fi/lanyard-ui/font/CrazyFont';
import { JBButton } from '@jbhi-fi/lanyard-ui';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { useNavigate } from '../../PlatformFunctionality/utils/useNavigate';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { GoToLink } from '../../GoToLink/GoToLink';
import { ContentThemePalette } from '../../Contentful/transformers/ThemeTransformer';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { FlexText } from '../../FlexText/FlexText';
import { useResponsiveValue } from '../../hooks/useResponsiveValue';

type ProductBannerHeaderProps = {
  heading?: string;
  url?: string;
  overallEndDate?: string;
  theme?: ContentThemePalette;
};

export const ProductBannerHeader = ({ heading, url, overallEndDate, theme }: ProductBannerHeaderProps) => {
  const navigateTo = useNavigate();
  const isMobile = useBreakpoint('md', 'down');

  const { headingSize } = useResponsiveValue<{ headingSize: number }>({
    xs: { headingSize: 20 },
    md: { headingSize: 24 },
    lg: { headingSize: 34 },
    xl: { headingSize: 34 },
  });

  return (
    <div className={styles.headingEndDateContainer({ isMobile })}>
      <div
        className={styles.headingContainer}
        style={{
          background: theme?.headingBackground ?? 'transparent',
          boxShadow: theme?.headingBackground ? `2px 2px 0px 0px ${palette.primary.dark}` : 'unset',
          border: theme?.headingBackground ? `1px solid ${palette.primary.dark}` : 'unset',
        }}
      >
        <FlexText className={styles.headingText} isWidthOnly={!isMobile} maxFontSizePx={headingSize}>
          <CrazyFont
            style={{
              color: theme?.heading ?? palette.primary.light,
            }}
          >
            {heading}
          </CrazyFont>
        </FlexText>
        {isMobile && url ? (
          <GoToLink className={styles.mobileCollectionLink} href={url} label="View all" />
        ) : !isMobile && url ? (
          <JBButton
            label="View all"
            onClick={() => {
              navigateTo(url);
            }}
            type="secondary"
          />
        ) : null}
      </div>
      {overallEndDate ? (
        <div className={styles.endDateContainer}>
          <CalloutFont className={styles.endDateText}>Ends {overallEndDate}</CalloutFont>
        </div>
      ) : null}
    </div>
  );
};
